module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand1.e4643b5466c43edb5bbf31dbd5c69f3e.png";